export const buildCumulativePages = (dailyPages: readonly number[]): number[] => {
  let total = 0;
  return dailyPages.map((value) => {
    total += Number.isFinite(value) ? value : 0;
    return Math.round(total);
  });
};
